import PropTypes from "prop-types";
import React, { useEffect } from "react";
import MiscPageLayout from "../../components/FullPageLayout/MiscPageLayout";
import { Typography, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import WarningIcon from "@mui/icons-material/Warning";
import { fetchSupportInfo } from "../../redux/actions/supportActions";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  divider: {
    width: 1,
    backgroundColor: theme.palette.secondary[300],
    margin: theme.spacing(0, 1),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  link: {
    color: theme.palette.primary.main,
    cursor: "pointer"
  }
}));

const ErrorPage = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { supportInfo, error } = props;
  const externalError = new URLSearchParams(window.location.search).get(
    "error"
  );

  const translationKey = `error.${externalError ||
    error.translationKey ||
    "generic"}`;

  useEffect(() => {
    props.fetchSupportInfo();
  }, []);

  return (
    <MiscPageLayout
      startIcon={<WarningIcon fontSize="inherit" />}
      title={
        <Typography variant="h1">{t(`${translationKey}.title`)}</Typography>
      }
      subtitle={
        <Box pl={{ xs: 7, sm: 18.5, lg: 0 }}>
          <Typography variant="h6">
            {t(`${translationKey}.subtitle`)}
          </Typography>
        </Box>
      }
    >
      {supportInfo.header && (
        <Box display="flex" flexDirection="column" mt={8} mb={2}>
          <Typography variant="h5">{supportInfo.header}</Typography>
        </Box>
      )}
      {supportInfo.message && (
        <Typography variant="body1" color="textSecondary">
          <div dangerouslySetInnerHTML={{ __html: supportInfo.message }} />
        </Typography>
      )}
      <Box
        flexDirection={{ xs: "column", sm: "row" }}
        display="flex"
        flex={{ xs: 1, sm: 0 }}
        justifyContent="space-between"
        mt={5}
        mb={4}
      >
        <div>
          <Typography variant="subtitle1">{t("support.email")}</Typography>
          <Typography color="textSecondary">
            <span className={classes.link}>{supportInfo.email}</span>
          </Typography>
        </div>
        <div className={classes.divider} />
        <div>
          <Typography variant="subtitle1">{t("support.hours")}</Typography>
          <Typography color="textSecondary">
            {supportInfo.operationHours}
          </Typography>
        </div>
        <div className={classes.divider} />
        <div>
          <Typography variant="subtitle1">{t("support.phone")}</Typography>
          <Typography color="textSecondary">
            {supportInfo.phoneNumber}
          </Typography>
        </div>
        <div />
      </Box>
    </MiscPageLayout>
  );
};

ErrorPage.propTypes = {
  supportInfo: PropTypes.object
};

const mapDispatchToProps = {
  fetchSupportInfo
};

const mapStateToProps = state => ({
  supportInfo: state.supportState.supportInfo.graceHillSupport,
  error: state.errorState.error || {}
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
